module.exports = __webpack_public_path__ + "static/media/arrow-left.46b3b162.svg";